export default __webpack_public_path__ + "static/media/maintenance-data-category-icon.c94471b5.svg";